import React from 'react';
import ReactDOM from 'react-dom/client';
import { Refine } from '@refinedev/core';
import { BrowserRouter } from 'react-router-dom';
import routerProvider from '@refinedev/react-router-v6';
import { useNotificationProvider } from '@refinedev/antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { authProvider } from './providers/authProvider';
import { dataProvider } from './providers/dataProvider';
import { App } from './App';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

// Create QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Refine
        authProvider={authProvider}
        dataProvider={dataProvider(API_URL)}
        notificationProvider={useNotificationProvider}
        routerProvider={routerProvider}
        resources={[
          {
            name: 'sandboxes',
            list: '/sandboxes',
            show: '/sandboxes/show/:id',
            create: '/sandboxes/create',
            meta: {
              canDelete: true,
            },
          },
          {
            name: 'analytics',
            list: '/analytics',
            meta: {
              label: 'Analytics',
            },
          },
        ]}
        options={{
          syncWithLocation: true,
          warnWhenUnsavedChanges: true,
        }}
      >
        <App />
      </Refine>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
